<template>
  <div
    class="container"
    :style="{
      width: cssProp(716 * scale),
      height: cssProp(625 * scale),
      pointerEvents: 'none'
    }"
  >
    <div :style="{ scale }">
      <div v-for="(component, position) in components" :key="position">
        <ingredient-image-composition
          v-if="
            component.selected && showIngredientComposition(component.selected)
          "
          :product="component.selected"
          :compositionImageGroups="compositionImageGroups(component.selected)"
          :scale="scale"
        ></ingredient-image-composition>
        <img
          v-else-if="component.selected"
          :src="componentImage(component)"
          class="image"
          :style="{
            top: cssProp(component.top - 400, '0'),
            left: cssProp(component.left - 20, '0'),
            width: cssProp(component.width, 'auto'),
            height: cssProp(component.height, 'auto'),
            zIndex: component.zIndex + 1
          }"
        />
        <img
          v-else
          :src="component.placeholder"
          class="image"
          :style="{
            top: cssProp(component.top - 400, '0'),
            left: cssProp(component.left - 20, '0'),
            width: cssProp(component.width, 'auto'),
            height: cssProp(component.height, 'auto'),
            zIndex: component.zIndex + 1
          }"
        />
      </div>
    </div>
  </div>
</template>

<script>
import IngredientImageComposition from "@/components/common/IngredientImageComposition";
import { generateCompositionImageGroups } from "@/utils/compositionImageUtil";

export default {
  name: "ComboProductImage",
  components: { IngredientImageComposition },
  methods: {
    cssProp(value, default_value) {
      if (value) return Math.round(value * this.scale) + "px";
      return default_value;
    },
    componentImage(component) {
      return component.selected.composition_image
        ? component.selected.composition_image
        : component.selected.selectedSize &&
          component.selected.selectedSize.alternate_picture
        ? component.selected.selectedSize.alternate_picture
        : component.selected.image;
    },
    showIngredientComposition(product) {
      console.log(
        "ComboProductImage - showIngredientComposition: " +
          product.master_category_name
      );
      let composition = generateCompositionImageGroups(product);
      return composition.length > 0;
    },
    compositionImageGroups(product) {
      console.log(
        "ComboProductImage - compositionImageGroups: " +
          product.master_category_name
      );
      return generateCompositionImageGroups(product);
    }
  },
  props: {
    components: {
      type: Array,
      default: () => []
    },
    scale: {
      type: Number,
      default: 1.0
    },
    top: {
      type: Number,
      default: 0
    },
    left: {
      type: Number,
      default: 0
    },
    ingredientCompositionOffset: {
      type: Array,
      default: () => [0, 0]
    }
  }
};
</script>

<style scoped>
.container {
  position: relative;
  z-index: 50;
  padding: 0;
}

.container > div {
  width: 716px;
  height: 625px;
  transform-origin: top left;
}

.orderList .container {
  //position: relative;
}

.image {
  position: absolute;
  object-fit: contain;
  pointer-events: none;
}
</style>
